<template>
  <BasePageContent>
    <BasePageHeader
      class="px-3"
      sectiontitle="VENDOR DETAIL"
      :title="!Util.isEmpty(Vendor) ? Vendor.vendor_name : ''"
      :description="!Util.isEmpty(Vendor) ? Vendor.email : ''"
    >
      <ul class="nk-block-tools g-1">
        <template v-if="!Util.isEmpty(Vendor)">
          <li class="nk-block-tools-opt">
            <router-link
              :to="{ name: 'vendor-edit', params: { uuid: Vendor.uuid } }"
              class="btn w3-theme w3-hover-theme btn-dim btn-outline-light"
            >
              <em class="icon ni ni-edit"></em>
              <span>Edit</span>
            </router-link>
          </li>
          <li>
            <div class="drodown">
              <a
                href="#"
                class="dropdown-toggle btn btn-white btn-dim btn-outline-light"
                data-toggle="dropdown"
              >
                <em class="icon ni ni-more-h"></em
              ></a>
              <div class="dropdown-menu dropdown-menu-right">
                <ul class="link-list-opt no-bdr">
                  <li>
                    <a title="Email Vendor" href="#">
                      <em class="dd-indc icon ni ni-mail-fill"></em>
                      <span>Email Vendor</span>
                    </a>
                  </li>
                  <li>
                    <a title="Create New Invoice" href="#">
                      <em class="dd-indc icon ni ni-file"></em>
                      <span>New Bill</span>
                    </a>
                  </li>
                  <li>
                    <a title="Create New Purchase Order" href="#">
                      <em class="dd-indc icon fas fa-file-alt"></em>
                      <span>New Purchase Order</span>
                    </a>
                  </li>
                  <li>
                    <a
                      title="Delete"
                      class="w3-text-red w3-hover-text-black"
                      @click.prevent="DeleteDetail(Vendor.uuid)"
                      href="#"
                    >
                      <em class="dd-indc icon ni ni-trash"></em>
                      <span> Delete Vendor</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li class="nk-block-tools-opt">
            <router-link :to="{ name: 'vendors' }" class="px-2" title="Back">
              <em class="icon ni ni-cross size36"></em>
            </router-link>
          </li>
        </template>
      </ul>
    </BasePageHeader>
    <div class="card-inner card-inner-md">
      <BaseIndicator
        text="Fetching vendor detail..."
        class="my-4"
        v-if="Util.fetching('getVendor')"
        :size="50"
      />
      <template v-else>
        <template v-if="!Util.isEmpty(Vendor)">
          <div
            class="
              w3-white
              py-0
              px-4
              w3-border-bottom
              d-flex
              align-items-center
              justify-content-between
            "
          >
            <div class="d-flex align-items-center justify-content-between">
              <button
                v-for="view in Views"
                :key="view"
                @click.prevent="SwitchView(view)"
                class="w3-button px-2 pt-3 w3-hover-transparent"
                :class="[
                  ActiveView === view
                    ? 'pb-1 w3-bottombar w3-border-theme'
                    : ' pb-2',
                ]"
              >
                <i
                  class="w3-text-theme w3-hover-text-theme"
                  :class="ViewsIcons[view]"
                />
                <span class="w3-hide-small ml-1">{{ ViewsNames[view] }}</span>
              </button>
            </div>
          </div>
          <div class="p-md-5 p-3">
            <div v-if="IsActiveView('Contact')" class="">
              <h4 class="mb-2">
                <i class="mr-1" :class="ViewsIcons['Contact']" /> Contact
                Information
              </h4>
              <div class="p-1">
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Vendor name
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.vendor_name ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    First name
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.firstname ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Last name
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.lastname ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Mobile
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.mobile ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Telephone
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.telephone ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Fax
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.fax ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Email
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.email ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Website
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.website ?? "-" }}
                  </div>
                </div>
              </div>
              <div class="p-1">
                <div class="row w3-border-bottom">
                  <div class="col-sm-12 w3-mobile px-2 pt-2 bold size13">
                    Internal Note
                  </div>
                  <div
                    class="col-sm-12 w3-mobile px-2 pt-md-2 pb-2 min-height140"
                    v-html="Util.nl2br(Vendor.internal_note) ?? '-'"
                  ></div>
                </div>
              </div>
            </div>
            <div v-if="IsActiveView('Address')" class="">
              <h4 class="mb-2">
                <i class="mr-1" :class="ViewsIcons['Address']" /> Address
                Information
              </h4>
              <div class="p-1">
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Billing Address
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.address ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    City
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.city ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    State
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.state_name ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Zip/Postcode
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.postcode ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Country
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Vendor.country_name ?? "-" }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="IsActiveView('Bills')" class="">
              <h4 class="mb-2">
                <i class="mr-1" :class="ViewsIcons['Bills']" /> Vendor Bills
              </h4>
              <div class="row">
                <div class="col-md-6">
                  <div class="p-1"></div>
                </div>
                <div class="col-md-6">
                  <div class="p-1"></div>
                </div>
              </div>
            </div>
            <div v-if="IsActiveView('PurchaseOrders')" class="">
              <h4 class="mb-2">
                <i class="mr-1" :class="ViewsIcons['PurchaseOrders']" /> Vendor
                Purchase Orders
              </h4>
              <div class="row">
                <div class="col-md-6">
                  <div class="p-1"></div>
                </div>
                <div class="col-md-6">
                  <div class="p-1"></div>
                </div>
              </div>
            </div>
            <div v-if="IsActiveView('Transactions')" class="">
              <h4 class="mb-2">
                <i class="mr-1" :class="ViewsIcons['Transactions']" /> Vendor
                Transactions
              </h4>
              <div class="row">
                <div class="col-md-6">
                  <div class="p-1"></div>
                </div>
                <div class="col-md-6">
                  <div class="p-1"></div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="p-5 w3-center">
          <img src="/images/item-not-found.png" class="mb-4" />
          <h4>Vendor not found</h4>
          <router-link
            :to="{ name: 'vendors' }"
            class="w3-button w3-white w3-border"
          >
            <span class="">Manage Vendors</span>
          </router-link>
        </div>
      </template>
    </div>
  </BasePageContent>
</template>

<script>
import { ref, toRef } from "vue";
import { useStore } from "vuex";
// import { useRouter } from "vue-router";
import { Util } from "@/helpers/utilities";
// import VendorUpdate from "@/components/ui/vendor/VendorUpdate.vue";
// import Aside from "@/components/ui/Aside.vue";
export default {
  components: {
    // Aside,
    // VendorUpdate
  },
  props: {
    vendor: {
      type: Object,
    },
    uuid: {
      type: String,
    },
  },
  emits: ["oncancel"],
  setup(props) {
    const store = useStore();
    console.log("props.uuid", props.uuid);
    const fetching = ref(true);
    const Vendor = ref({});
    const VENDOR = toRef(props, "vendor");
    const GetVendor = async () => {
      Vendor.value = {};
      if (props.uuid) {
        const _vendor = await store.dispatch("vendors/getVendor", props.uuid);
        Vendor.value = {
          ..._vendor,
        };
      } else if (VENDOR.value) {
        Vendor.value = VENDOR.value;
      } else {
        Vendor.value = {};
      }
      fetching.value = false;
    };
    GetVendor();
    // TAB VIEWS
    const Views = [
      "Contact",
      "Address",
      "Bills",
      "PurchaseOrders",
      "Transactions",
    ];
    const ActionViews = ["Edit", "Delete"];
    const ViewsIcons = {
      Contact: "fas fa-user-tie",
      Address: "fas fa-map-marker-alt",
      Bills: "fas fa-file-invoice",
      PurchaseOrders: "fas fa-file-alt",
      Transactions: "icon bx bx-line-chart",
    };
    const ViewsNames = {
      Contact: "Contact",
      Address: "Address",
      Bills: "Bills",
      PurchaseOrders: "Purchase Orders",
      Transactions: "Transactions",
    };

    const ActiveView = ref(Views[0]);
    const IsActiveView = (view) => (ActiveView.value === view ? true : false);
    const SwitchView = (view) => {
      const newViewIndex = Views.indexOf(view);
      if (ActiveView.value === Views[newViewIndex]) return false;
      ActiveView.value = Views[newViewIndex];
      return true;
    };

    const DeleteVendor = (uuid) => {
      console.log(uuid);
    };
    const OnCancel = () => {
      if (props.uuid) {
        // router.push({
        //   name: "vendors",
        // });
      } else {
        // emit("oncancel");
      }
    };
    //  END TAB VIEWS

    return {
      store,
      fetching,
      Vendor,
      OnCancel,
      Views,
      ActionViews,
      ViewsIcons,
      ViewsNames,
      IsActiveView,
      ActiveView,
      SwitchView,
      Util,
      DeleteVendor,
    };
  },
};
</script>